/**
 * Format a past timestamp as a short relative phrase for UI chrome.
 * @param {string|number|Date|null|undefined} value
 * @returns {string|null}
 */
export function formatRelativePast(value) {
  if (value == null || value === "") return null;
  const date = value instanceof Date ? value : new Date(value);
  const ms = date.getTime();
  if (!Number.isFinite(ms)) return null;

  const diffMs = Date.now() - ms;
  if (diffMs < 0) return null;

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;

  if (diffMs < minute) return "just now";
  if (diffMs < hour) {
    const n = Math.floor(diffMs / minute);
    return n === 1 ? "1 min ago" : `${n} min ago`;
  }
  if (diffMs < day) {
    const n = Math.floor(diffMs / hour);
    return n === 1 ? "1h ago" : `${n}h ago`;
  }
  if (diffMs < 7 * day) {
    const n = Math.floor(diffMs / day);
    return n === 1 ? "1d ago" : `${n}d ago`;
  }
  if (diffMs < 30 * day) {
    const n = Math.floor(diffMs / (7 * day));
    return n === 1 ? "1w ago" : `${n}w ago`;
  }

  try {
    return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  } catch {
    return null;
  }
}
